import styled from "@emotion/styled";
import { formInputTheme, TextInputRootBoxProps } from "./formInputTheme";

type StyledContentAfterContainerProps = Pick<
    TextInputRootBoxProps,
    "themeMode" | "validationState" | "focusMode" | "isFocused" | "variant"
>;

// not using sizing constant due to the 2px border (would be 8/sizes.xSmall)
export const StyledContentAfterContainer = styled("div")`
    padding-right: ${getPadding};
    padding-left: var(--sds--form-input--content-after--padding--left, 0px);
    display: flex;
`;

function getPadding({ themeMode, validationState, focusMode, isFocused, variant }: StyledContentAfterContainerProps) {
    if (variant === "underline") {
        //underline paddings don't change based on state
        return `${formInputTheme.padding.right.contentAfter(themeMode)}`;
    } else if (validationState === "error" || (isFocused && focusMode !== "keyboard")) {
        return `${formInputTheme.padding.right.active(themeMode)}`;
    } else {
        return `${formInputTheme.padding.right.rest(themeMode)}`;
    }
}
